import { userService } from "src/services/api";
import _ from "lodash";

const state = {
  status: {},
  errors: [],
  statusText: "",
  data: [],
  metaData: {},

  dataAvailable: [],
  metaDataAvailable: {},

  jobAvailable: [],
  metaDataJobAvailable: {},

  single: {},
  dataParam: {
    keyword: "",
    page: "",
    limit: 50,
  },

  tableFilter: {
    SearchTerm: null,
    isDeleted: null,
    isActive: null,
  },
  loadingTable: false,
};

const defaultFilter = {
  SearchTerm: null,
  isDeleted: null,
  isActive: null,
};

const actions = {
  async applyTableFilter({ commit, dispatch }, params) {
    commit("setTableFilter", {
      ...defaultFilter,
      ...params,
    });
    dispatch("getAll", params);
  },

  async clearTableFilter({ commit }) {
    commit("setTableFilter", {
      SearchTerm: null,
      isDeleted: null,
      isActive: null,
    });
  },

  async clearFilter({ commit }) {
    commit("clearFilterField", []);
    commit("setFilter", {
      keyword: "",
      page: "",
      limit: 50,
    });
  },

  async search({ commit }, params = { keyword: "", page: "", limit: 50 }) {
    commit("setFilter", params);
  },

  async update({ dispatch, commit }, payload) {
    await userService.update(payload).then(
      () => {
        // commit("statusOk");
      },
      (error) => {
        commit("createFailure", error);
        dispatch("alert/error", error, { root: true });
      }
    );
  },

  async getById({ commit }, id) {
    await userService.getById(id).then(
      (response) => {
        commit("setSingle", response.data);
      },
      (error) => commit("getAllFailure", error)
    );
  },

  async getAll({ commit }, payload = {}) {
    commit("setLoadingTable", true);
    await userService.getAll(payload).then(
      (response) => {
        commit("setData", response.data);
        commit("setMetaData", response.metaData);
        commit("setLoadingTable", false);
      },
      (error) => {
        commit("getAllFailure", error);
        commit("setLoadingTable", false);
      }
    );
  },

  async getAllAvailable({ commit }, payload = {}) {
    commit("setLoadingTable", true);
    await userService.getAllAvailable(payload).then(
      (response) => {
        commit("setDataAvailable", response.data);
        commit("setMetaDataAvailable", response.metaData);
        commit("setLoadingTable", false);
      },
      (error) => commit("getAllFailure", error)
    );
  },

  async getAllAvailableForJob({ commit }, payload = {}) {
    commit("setLoadingTable", true);
    await userService.getAllAvailable(payload).then(
      (response) => {
        commit("setJobAvailable", response.data);
        commit("setMetaDataJobAvailable", response.metaData);
        commit("setLoadingTable", false);
      },
      (error) => commit("getAllFailure", error)
    );
  },

  async delete({ commit }, id) {
    commit("deleteRequest", id);
    await userService.delete(id).then(
      (user) => commit("deleteSuccess", id, user),
      (error) => commit("deleteFailure", { id, error: error.toString() })
    );
  },

  async reactive({ commit, dispatch }, id) {
    await userService.reactive(id).then(
      () => {
        dispatch("snackbar/success", `Reactive user successful`, {
          root: true,
        });
      },
      (error) => commit("deleteFailure", { id, error: error.toString() })
    );
  },

  clearData({ commit }) {
    commit("setData", []);
  },
};

const mutations = {
  setLoadingTable(state, data) {
    state.loadingTable = data;
  },

  setTableFilter(state, data) {
    state.tableFilter = data;
  },

  setFilter(state, param) {
    state.dataParam = param;
  },
  setData(state, data) {
    state.data = data;
  },
  setMetaData(state, data) {
    state.metaData = data;
  },
  setDataAvailable(state, data) {
    state.dataAvailable = data;
  },
  setMetaDataAvailable(state, data) {
    state.metaDataAvailable = data;
  },
  setJobAvailable(state, data) {
    state.jobAvailable = data;
  },
  setMetaDataJobAvailable(state, data) {
    state.metaDataJobAvailable = data;
  },
  setSingle(state, data) {
    state.single = data;
  },
  getAllRequest(state) {
    state.all = { loading: true };
  },
  getAllSuccess(state, users) {
    state.all = { items: users };
  },
  getAllFailure(state, error) {
    state.all = { error };
  },
  deleteRequest(state, id) {
    // add 'deleting:true' property to user being deleted
    state.all.items = state.all.items.map((user) =>
      user.id === id ? { ...user, deleting: true } : user
    );
  },
  deleteSuccess(state, id) {
    // remove deleted user from state
    state.all.items = state.all.items.filter((user) => user.id !== id);
  },
  deleteFailure(state, { id, error }) {
    // remove 'deleting:true' property and add 'deleteError:[error]' property to user
    state.all.items = state.items.map((user) => {
      if (user.id === id) {
        // make copy of user without 'deleting:true' property
        //                const { deleting, ...userCopy } = user;
        const { ...userCopy } = user;
        // return copy of user with 'deleteError:[error]' property
        return { ...userCopy, deleteError: error };
      }

      return user;
    });
  },
};

const getters = {
  getMetaData(state) {
    return state.metaData;
  },
  getAllAvailable(state, current, rootState) {
    //  this is fast fix, once backend fixed, it need to be removed/adjusted
     current, rootState;
     return state.dataAvailable;
    // current;
    // let today = new Date();
    // let todayDate =
    //   today.getFullYear() +
    //   "-" +
    //   ("0" + (today.getMonth() + 1)).slice(-2) +
    //   "-" +
    //   ("0" + today.getDate()).slice(-2);

    // let allAvailable = state.data;
    // let todayTask = rootState.task.data;
    // todayTask = todayTask
    //   .map((task) => {
    //     return {
    //       ...task,
    //       date: task.date.substr(0, 10),
    //       endDate: task.endDate ? task.endDate.substr(0, 10) : "",
    //     };
    //   })
    //   .filter((task) => task.date == todayDate);

    // let notAvailableUser = todayTask
    //   .map((task) => task.taskUsers)
    //   .filter((task) => task.length > 0);

    // let usersNotAvail = [];
    // notAvailableUser.forEach((userList) => {
    //   userList.forEach((us) => {
    //     usersNotAvail.push(us.userId);
    //   });
    // });

    // return allAvailable.filter((user) => {
    //   return !usersNotAvail.includes(user.id);
    // });
  },
  getAll(state) {
    let data = state.data;
    const { SearchTerm } = state.tableFilter;
    if (SearchTerm) {
      data = _.filter(
        data,
        _.flow(
          _.identity,
          _.values,
          _.join,
          _.toLower,
          _.partialRight(_.includes, SearchTerm.toString().toLowerCase())
        )
      );
    }
    return data;
  },

  getAllFromLatest(state) {
    return state.data.reverse();
  },
};

export const user = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
